import { createActionGroup, props } from '@ngrx/store';
import { ProjectManagerOption } from '@ps/survey-utils';

export const SurveyManagementActions = createActionGroup({
  source: 'Survey Management',
  events: {
    'Assign Buyer Project Manager': props<{
      surveyId: number;
      projectManager: ProjectManagerOption;
    }>(),
    'Remove Buyer Project Manager': props<{ surveyId: number }>(),
    'Assign Operator Project Manager': props<{
      surveyId: number;
      projectManager: ProjectManagerOption;
    }>(),
    'Remove Operator Project Manager': props<{ surveyId: number }>(),
  },
});

export const SurveyManagementApiActions = createActionGroup({
  source: 'Survey Management API',
  events: {
    'Assign Buyer Project Manager Success': props<{
      surveyId: number;
      projectManager: ProjectManagerOption;
    }>(),
    'Assign Buyer Project Manager Failure': props<{ error: string }>(),
    'Remove Buyer Project Manager Success': props<{ surveyId: number }>(),
    'Remove Buyer Project Manager Failure': props<{ error: string }>(),
    'Assign Operator Project Manager Success': props<{
      surveyId: number;
      projectManager: ProjectManagerOption;
    }>(),
    'Assign Operator Project Manager Failure': props<{ error: string }>(),
    'Remove Operator Project Manager Success': props<{ surveyId: number }>(),
    'Remove Operator Project Manager Failure': props<{ error: string }>(),
  },
});
